import { Directive, TemplateRef, input } from '@angular/core';

export declare class PaginationTableStateErrorDirectiveContext {
	$implicit: any;
	defaultTemplate: TemplateRef<any>;
}

@Directive({
	selector: 'ng-template[aePgtStateError]',
})
export class PaginationTableStateErrorDirective {
	readonly disabled = input(false);

	constructor(
		public template: TemplateRef<PaginationTableStateErrorDirectiveContext>,
	) {}

	static ngTemplateGuard_aePgtSearch: 'binding';
	static ngTemplateContextGuard(
		_dir: PaginationTableStateErrorDirective,
		_ctx: any,
	): _ctx is PaginationTableStateErrorDirectiveContext {
		return true;
	}
}
